import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[craftUploadOver]',
  standalone: false,
})
export class UploadOverDirective {
  @Input() public overClass = 'over';
  @Output() public filesDrop: EventEmitter<FileList> = new EventEmitter<FileList>();

  private counter = 0;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('dragenter', ['$event'])
  public onDragEnter(_e: Event): void {
    this.counter++;
    this.addClass(this.overClass);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(_e: Event): void {
    this.counter--;
    if (this.counter === 0) {
      this.removeClass(this.overClass);
    }
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(e: Event): void {
    this.cancelEvent(e);
  }

  @HostListener('drop', ['$event'])
  public onDrop(e: any): void {
    this.counter = 0;
    this.cancelEvent(e);
    this.removeClass(this.overClass);

    const files = e.dataTransfer.files as FileList;
    this.filesDrop.emit(files);
  }

  private cancelEvent(e: Event): void {
    e.preventDefault();
  }

  private addClass(className: string): void {
    this.renderer.addClass(this.el.nativeElement, className);
  }

  private removeClass(className: string): void {
    this.renderer.removeClass(this.el.nativeElement, className);
  }
}
